import { calendarDateIn } from './datetime';
import type { PublicEvent, Session } from './queries';

export type EventPhase = 'before' | 'during' | 'after';

export function eventPhase(event: PublicEvent, now: Date): EventPhase {
  const today = calendarDateIn(event.timezone, now);

  if (today < event.startsOn) {
    return 'before';
  }
  return today > event.endsOn ? 'after' : 'during';
}

/** The day the attendee is actually standing in, or null outside the event. */
export function currentDay(event: PublicEvent, now: Date) {
  const today = calendarDateIn(event.timezone, now);
  return event.days.find((day) => day.date === today) ?? null;
}

/** The day the program should open at: today during the event, otherwise the first day (PRG-04). */
export function defaultProgramDayKey(event: PublicEvent, now: Date): string | undefined {
  return (currentDay(event, now) ?? event.days.at(0))?.key;
}

export function isHappeningNow(session: Session, now: Date): boolean {
  const start = Date.parse(session.startsAt);
  const end = Date.parse(session.endsAt);
  return !session.isCancelled && start <= now.getTime() && now.getTime() < end;
}

export function nextUp(sessions: Session[], now: Date): Session | null {
  return sessions.find((session) => Date.parse(session.startsAt) > now.getTime()) ?? null;
}
